import React, { useState, useEffect } from "react";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api_url } from "../config/config";
import DeletePrompt from "../Components/common/DeletePrompt";

const ManageStores = () => {
    const [vendors, setVendors] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [branchToDelete, setBranchToDelete] = useState(null);
    const navigate = useNavigate();
    const [trigger, setTrigger] = useState(false);
    const token = localStorage.getItem("admin_token");

    useEffect(() => {
         fetchBranches();
    }, [searchTerm]);


    const handleEdit = (branchId, branch) => {
        navigate(`/ng-admin/edit-branch/${branchId}`,{state:{
            branchId:branchId,
            branch:branch,
        }});
    };

    const handleDelete = async (branch_id) => {
        try {
            await axios.delete(`${api_url}/branch/${branch_id}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
                  },
            });
            setTrigger((prev) => !prev);
            setShowConfirm(false);
            setBranchToDelete(null);
            fetchBranches();
            toast.success("Successfully Deleted");
        } catch (e) {
            toast.error(e.message);
        }
    };

    const fetchBranches = async () => {
    try {
      const response = await axios.get(`${api_url}/branches?search=${searchTerm}`);

      const rawBranches = response.data.results || [];

      const uniqueBranches = [
        ...new Map(
          rawBranches.map((branch) => [branch.branch_id, branch])
        ).values(),
      ];

      setBranches(uniqueBranches);
      console.log("Unique Branches:", uniqueBranches);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };
    useEffect(() => {
        fetchBranches();
    }, []);

    return (
        <div className="flex flex-col">
                <ToastContainer />
        <div className="flex-grow overflow-auto">
            <h2 className="text-2xl font-bold mb-4 mt-7">Stores List</h2>
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="w-full flex items-center justify-between gap-5 mb-4">
                    <input
                        type="text"
                        className="border rounded-xl border-slate-700 p-2 w-[300px] px-3"
                        placeholder="Search by Branch Name, Address, contact number"
                        title="Search by Branch Name, Address, contact number"
                        value={searchTerm}
                        onChange={e => {
                            setSearchTerm(e.target.value);
                        }}
                    />
                    <button
                        className="bg-[#3C1F1F] text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
                        onClick={() => navigate("/ng-admin/add-branch")}
                    >
                        Add Store
                    </button>
                </div>
                <table className="table-auto w-full text-sm text-left">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-6 py-3">Branch Id</th>
                            <th className="px-6 py-3">Branch Name</th>
                            <th className="px-6 py-3">Address</th>
                            <th className="px-6 py-3">Pincode</th>
                            <th className="px-6 py-3">Contact Number</th>
                            <th className="px-6 py-3">Location</th>
                            <th className="px-6 py-3">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="overflow-y-auto max-h-[400px]">
                        {branches.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="text-center py-8 text-gray-500">
                                    No branches found matching your search.
                                </td>
                            </tr>
                        ) : (
                            branches.map((branch) => (
                                <tr key={branch.id} className="hover:bg-gray-100">
                                    <td className="px-6 py-3">{branch.branch_id || "N/A"}</td>
                                    <td className="px-6 py-3">{branch.area}</td>
                                    <td className="px-6 py-3">{branch.branch_address || "N/A"}</td>
                                    <td className="px-6 py-3">{branch.pincode || "N/A"}</td>
                                    <td className="px-6 py-3">
                                        {branch.contact_number ? branch.contact_number : "N/A"}
                                    </td>
                                    <td className="px-6 py-3">
                                        <a
                                            href={branch.location}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                        {branch.location || "N/A"}
                                        </a>
                                    </td>

                                    <td className="px-6 py-6 flex space-x-2">
                                        <PencilSquareIcon
                                            className="h-5 w-5 text-[#3C1F1F] cursor-pointer hover:text-blue-700"
                                            onClick={() => handleEdit(branch.branch_id, branch)}
                                        />
                                        <TrashIcon
                                            className="h-5 w-5 text-red-500 cursor-pointer hover:text-red-700"
                                            onClick={
                                                () => {
                                                    setBranchToDelete(branch.branch_id);
                                                    setShowConfirm(true);
                                                }
                                            }
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                {/* {renderPagination()} */}
            </div>
        </div>
        <DeletePrompt
            showModal={showConfirm}
            onDelete={() => branchToDelete && handleDelete(branchToDelete)}
            onCancel={() => {
                setShowConfirm(false);
                setBranchToDelete(null);
            }}
        />
    </div>
    
    );
};

export default ManageStores;
